const wowApp = require('angular').module('wowApp.common');

wowApp.controller('PageMetadataController', ['$location', 'PageMetadataService', require('./page-metadata-controller')]);

wowApp.service('PageMetadataService', ['Restangular', '$location', '$state', '$q', '$window', 'AnalyticsService', require('./page-metadata.service')]);



// WEBPACK FOOTER //
// ./src/common/pagemetadata/index.js